export default "__VITE_ASSET__bbcefab7__"